'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

import { useAccessControl } from '@/utils/hooks/middleware/useAccessControl';

import LoaderPage from '@/components/base/Loader/LoaderPage';

type AccessControlProps = { children: React.ReactNode };

export function AccessControl({ children }: AccessControlProps) {
    const router = useRouter();
    const { hasAccess, redirect_url } = useAccessControl();

    useEffect(() => {
        if (!hasAccess && redirect_url) {
            // No locale prefix needed (localePrefix: 'never')
            router.push(redirect_url);
        }
    }, [hasAccess, redirect_url, router]);

    if (!hasAccess) {
        return <LoaderPage />;
    }

    return children;
}
